import React from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const Wrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
}));

const MainWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default MainWrapper;
